const statusColors: Record<string, string> = {
  // Green
  ready: 'bg-green-100 text-green-800',
  'ready to sign': 'bg-green-100 text-green-800',
  complete: 'bg-green-100 text-green-800',
  completed: 'bg-green-100 text-green-800',
  active: 'bg-green-100 text-green-800',
  won: 'bg-green-100 text-green-800',
  paid: 'bg-green-100 text-green-800',
  yes: 'bg-green-100 text-green-800',
  true: 'bg-green-100 text-green-800',

  // Yellow
  pending: 'bg-yellow-100 text-yellow-800',
  'under review': 'bg-yellow-100 text-yellow-800',
  'in progress': 'bg-yellow-100 text-yellow-800',
  submitted: 'bg-yellow-100 text-yellow-800',
  draft: 'bg-yellow-100 text-yellow-800',

  // Red
  error: 'bg-red-100 text-red-800',
  failed: 'bg-red-100 text-red-800',
  cancelled: 'bg-red-100 text-red-800',
  lost: 'bg-red-100 text-red-800',
  closed: 'bg-red-100 text-red-800',
  no: 'bg-red-100 text-red-800',
  false: 'bg-red-100 text-red-800',

  // Blue
  new: 'bg-blue-100 text-blue-800',
  open: 'bg-blue-100 text-blue-800',
  processing: 'bg-blue-100 text-blue-800',

  // Gray
  inactive: 'bg-gray-100 text-gray-800',
  unknown: 'bg-gray-100 text-gray-600',
};

const dotColors: Record<string, string> = {
  'bg-green-100 text-green-800': 'bg-green-500',
  'bg-yellow-100 text-yellow-800': 'bg-yellow-500',
  'bg-red-100 text-red-800': 'bg-red-500',
  'bg-blue-100 text-blue-800': 'bg-blue-500',
  'bg-gray-100 text-gray-800': 'bg-gray-500',
  'bg-gray-100 text-gray-600': 'bg-gray-400',
};

interface StatusBadgeProps {
  value: string | boolean | null | undefined;
}

export default function StatusBadge({ value }: StatusBadgeProps) {
  if (value == null || value === '') return <span className="text-gray-400">-</span>;

  const str = String(value);
  const key = str.toLowerCase().trim();
  const colorClass = statusColors[key] || 'bg-gray-100 text-gray-600';
  const dotClass = dotColors[colorClass] || 'bg-gray-400';

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${colorClass}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${dotClass}`} />
      {str}
    </span>
  );
}
